module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_36.f3413019.png";